import clsx from "clsx";
import React, { forwardRef } from "react";
import dayjs from "../../../utils/dayjs";
import { PriceStatus } from "../Calendar/Calendar";
import * as styles from "./DateButton.module.css";
const DateButton = ({
  className,
  value,
  isDisabled,
  isSelected,
  onClick,
  onChange,
  children,
  getAriaLabel,
  "aria-label": ariaLabel,
  ...props
}, forwardedRef) => {
  const isTodayDate = dayjs(value).isToday();
  return /* @__PURE__ */ React.createElement("button", {
    "data-testid": `jsf-calendar-date-button-${dayjs(value).date()}`,
    ...props,
    role: "gridcell",
    "aria-label": ariaLabel || (getAriaLabel == null ? void 0 : getAriaLabel(dayjs(value).local().format("dddd, MMMM D, YYYY"), PriceStatus.NOT_REQUIRED)),
    ref: forwardedRef,
    className: clsx(styles.root, className),
    type: "button",
    "aria-current": isTodayDate ? "date" : false,
    "aria-selected": isSelected,
    "aria-disabled": isDisabled,
    tabIndex: isSelected ? 0 : -1,
    onClick: (event) => {
      onClick == null ? void 0 : onClick(event);
      onChange(event, value);
    }
  }, children || dayjs(value).local().format("D"));
};
var DateButton_default = forwardRef(DateButton);
export {
  DateButton_default as default
};
